import { render, staticRenderFns } from "./SiteLicenses.vue?vue&type=template&id=0b006eb4&"
import script from "./SiteLicenses.vue?vue&type=script&lang=js&"
export * from "./SiteLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports